import { Button, Stack, Typography } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import CoinsPurpleSvg from '~/@ui/_sharedSvgs/ui/CoinsPurple.svg?react'

type Props = {
  className?: string
}

export const FirstInvestmentCard = ({ className = '' }: Props) => {
  const navigate = useNavigate()

  const toInvestments = () => navigate('/investor/opportunities')

  return (
    <Stack
      className={`
        px-4 pt-5 pb-4 bg-[#e8e2ff] rounded-4d
        ${className}
      `}>
      <Stack className="flex-row gap-2">
        <CoinsPurpleSvg />
        <Typography className="text-base font-bold text-zBlack200 mb-2.5">
          Prvá investícia
        </Typography>
      </Stack>
      <Typography className="text-3d font-medium text-zBlack200 mb-4">
        Stačí 25 € mesačne a môžete začať investovať.
      </Typography>
      <Button
        onClick={toInvestments}
        variant="contained"
        className="w-fit px-6 bg-[#b3a0ff]">
        <Typography className="text-3d font-medium text-zBlack200">
          Začať investovať
        </Typography>
      </Button>
    </Stack>
  )
}
